"use client";

import Script from "next/script";
import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";

import { captureMetaAttribution } from "./attribution";
import { metaPixel } from "./client";

const isAllowedHost = () => {
  if (typeof window === "undefined") return false;
  return ["book.selfieroom.ca", "localhost", "127.0.0.1"].includes(window.location.hostname);
};

export const isPublicBookingRoute = (pathname: string | null) => {
  if (!pathname || !isAllowedHost()) return false;
  if (pathname.startsWith("/api/") || pathname.startsWith("/settings") || pathname.startsWith("/admin")) {
    return false;
  }
  return (
    pathname === "/selfieroom" ||
    pathname.startsWith("/selfieroom/") ||
    pathname.startsWith("/d/") ||
    pathname.startsWith("/team/") ||
    /^\/payment\/[^/]+$/.test(pathname) ||
    /^\/booking\/[^/]+$/.test(pathname)
  );
};

export default function MetaTrackingRuntime() {
  const pathname = usePathname();
  const lastPathname = useRef<string | null>(null);
  const enabled = isPublicBookingRoute(pathname);

  useEffect(() => {
    if (!enabled || !process.env.NEXT_PUBLIC_META_PIXEL_ID) return;
    captureMetaAttribution();
    metaPixel.init();
    if (lastPathname.current !== pathname) {
      lastPathname.current = pathname;
      metaPixel.pageView();
    }
  }, [enabled, pathname]);

  if (!enabled || !process.env.NEXT_PUBLIC_META_PIXEL_ID) return null;
  return (
    <Script
      id="selfieroom-meta-pixel"
      src="https://connect.facebook.net/en_US/fbevents.js"
      strategy="afterInteractive"
    />
  );
}
